import React, { Component } from "react";
import {
  Card,
  Badge,
  ButtonDropdown,
  CustomInput,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  Row,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import {
  setContainerClassnames,
  clickOnMobileMenu,
} from "../../../../redux/actions";
import IntlMessages from "../../../../helpers/IntlMessages";
import classnames from "classnames";
import {
  Colxx,
  Separator,
} from "../../../../components/common/CustomBootstrap";

const formatCurrency = (value) => {
  if (!value) return "0";
  return parseInt(value, 10).toLocaleString("vi-VN");
};

// Hàm này sẽ render thông tin giảm giá một cách nhất quán
const renderDiscountInfo = (rule) => {
  const unit =
    rule.discountUnit ||
    (rule.discount_type === 2 ? "PERCENT" : "FIXED_AMOUNT");
  const value = formatCurrency(rule.discountValue || rule.discount_value);
  const maxDiscount =
    rule.maxDiscount || rule.max_discount || parseFloat(rule.maxDiscountAmount);

  if (unit === "PERCENT") {
    return (
      <>
        Giảm <strong>{value}%</strong>
        {maxDiscount &&
          ` (tối đa ${formatCurrency(
            maxDiscount.toString().replace(/\./g, "")
          )} VNĐ)`}
      </>
    );
  }
  return (
    <>
      Giảm{" "}
      <strong>{formatCurrency(value.toString().replace(/\./g, ""))} VNĐ</strong>
    </>
  );
};

class LabelItemLeft extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownSplitOpen: false,
      isVariantsOpen: false,
    };
  }

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleVariants = () => {
    this.setState({
      isVariantsOpen: !this.state.isVariantsOpen,
    });
  };

  menuButtonClick = (e, menuClickCount, containerClassnames) => {
    setTimeout(() => {
      var event = document.createEvent("HTMLEvents");
      event.initEvent("resize", false, false);
      window.dispatchEvent(event);
    }, 350);
    this.props.setContainerClassnames(
      menuClickCount,
      containerClassnames,
      this.props.selectedMenuHasSubItems
    );
  };

  onClickedItem = (item) => {
    this.props.onClickedItem(
      // callback
      item,
      this.menuButtonClick,
      [null, 1000, this.props.containerClassnames]
    );
  };

  findTypePromotion = (actionType, conditionType) => {
    if (actionType === "ORDER_DISCOUNT") {
      if (conditionType === "MIN_ORDER_VALUE") {
        return "total-order-value";
      } else if (conditionType === "CUSTOMER_POINTS") {
        return "customer-accrual-points";
      } else if (conditionType === "FIRST_ORDER") {
        return "first-order-discount";
      } else if (conditionType === "CUSTOMER_GROUP") {
        return "customer-group-discount";
      }
    } else if (actionType === "ITEM_DISCOUNT") {
      if (conditionType === "CONTAINS_PRODUCTS") {
        return "one-product";
      } else if (conditionType === "CONTAINS_CATEGORIES") {
        return "one-type-product";
      } else if (conditionType === "MIN_PRODUCT_QUANTITY") {
        return "quantity-product";
      } else if (conditionType === "MIN_CATEGORY_QUANTITY") {
        return "quantity-type-product";
      }
    } else if (actionType === "GIVE_GIFT") {
      if (conditionType === "CONTAINS_PRODUCTS") {
        return "product-get-product";
      } else if (conditionType === "MIN_ORDER_VALUE") {
        return "total-order-value-get-product";
      } else if (conditionType === "CUSTOMER_POINTS") {
        return "customer-accrual-points-get-product";
      }
    }
  };

  // --- HÀM MỚI: RENDER CHI TIẾT KHUYẾN MẠI ---
  renderPromotionDetails = (item) => {
    const { productMap, categoryMap } = this.props;
    // console.log('item: ', item);
    const type = this.findTypePromotion(
      item.actions[0].actionType,
      item.conditions[0].conditionType
    );

    if (!item.conditions || !item.actions)
      return <div className="p-3 text-muted">Không có dữ liệu chi tiết.</div>;

    const condition = item.conditions[0];
    const action = item.actions[0];

    // Helper để tìm tên, trả về ID nếu không tìm thấy
    const findProductName = (id) => productMap.get(id) || `Sản phẩm ID: ${id}`;
    const findCategoryName = (id) =>
      categoryMap.get(id) || `Danh mục ID: ${id}`;

    // Dùng switch-case để render theo loại
    switch (type) {
      case "total-order-value":
        return (
          <div className="p-4">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p className="mb-1">
              <strong>Điều kiện:</strong> Áp dụng cho tổng giá trị đơn hàng.
            </p>
            <p>
              Bắt đầu từ: {moment(item.startDate).format("DD-MM-YYYY")}{" "}
              {item.endDate
                ? `- đến: ${moment(item.endDate).format("DD-MM-YYYY")}`
                : null}
            </p>
            <p className="mb-2">
              <strong>Ưu đãi:</strong>
            </p>
            <ul className="mb-3 list-unstyled">
              {action?.actionItems?.map((rule, index) => (
                <li key={index} className="d-flex justify-content-between mb-1">
                  <span>
                    - Từ <strong>{formatCurrency(rule.fromValue)} VNĐ</strong>
                    {rule.toValue ? (
                      <span>
                        {" "}
                        đến <strong>{formatCurrency(rule.toValue)} VNĐ</strong>
                      </span>
                    ) : null}
                    :
                  </span>
                  <span>{renderDiscountInfo(rule)}</span>
                </li>
              ))}
            </ul>
          </div>
        );

      case "customer-accrual-points":
        return (
          <div className="p-4">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p>
              <strong>Điều kiện:</strong> Áp dụng theo mốc tích điểm của khách
              hàng.
            </p>
            <p className="mb-2">
              <strong>Ưu đãi:</strong>
            </p>
            <ul className="mb-3 list-unstyled">
              {action?.actionItems?.map((rule, index) => (
                <li key={index} className="d-flex justify-content-between mb-1">
                  <span>
                    - Từ <strong>{formatCurrency(rule.fromPoints)} điểm</strong>
                    :
                  </span>
                  <span>{renderDiscountInfo(rule)}</span>
                </li>
              ))}
            </ul>
          </div>
        );

      case "first-order-discount":
        return (
          <div className="p-4">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p>
              <strong>Điều kiện:</strong> Áp dụng cho khách hàng mới / đơn hàng
              đầu tiên.
            </p>
            <p className="mb-2">
              <strong>Ưu đãi:</strong>
            </p>
            <ul className="mb-3 list-unstyled">
              <li className="d-flex justify-content-between mb-1">
                <span>{renderDiscountInfo(action)}</span>
              </li>
            </ul>
          </div>
        );

      case "one-product":
      case "one-type-product":
        const isProduct = type === "one-product";
        return (
          <div className="p-3">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p>
              <strong>Điều kiện:</strong> Áp dụng cho từng{" "}
              {isProduct ? "sản phẩm" : "danh mục"}.
            </p>
            <p className="mb-2">
              <strong>Danh sách áp dụng:</strong>
            </p>
            <ul className="mb-3 list-unstyled">
              {action.actionItems.length &&
                action.actionItems.map((rule, index) => {
                  const name = isProduct ? "product" : "category";
                  return (
                    <>
                      <div
                        key={index}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <p className="mb-2">Combo {index + 1}</p>
                        <div className="d-flex flex-column">
                          {rule[name]
                            ? rule[name].map((prod, prodIndex) => (
                                <li key={`${index}-${prodIndex}`}>
                                  <div>- {prod.label}</div>
                                </li>
                              ))
                            : null}
                        </div>
                        <span>{renderDiscountInfo(rule)}</span>
                      </div>
                      {action.actionItems.length > 1 ? (
                        <Separator className="my-2" />
                      ) : null}
                    </>
                  );
                })}
              {/* {action.actionItems.map((rule, index) => (
                                <li key={index} className="d-flex justify-content-between mb-1">
                                    <span>- {isProduct ? findProductName(rule.productId) : findCategoryName(rule.categoryId)}</span>
                                    <span>{renderDiscountInfo(rule)}</span>
                                </li>
                            ))} */}
            </ul>
          </div>
        );

      case "quantity-product":
      case "quantity-type-product":
        const isQuantityProduct = type === "quantity-product";
        return (
          <div className="p-3">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p>
              <strong>Điều kiện:</strong> Áp dụng khi mua đủ{" "}
              {isQuantityProduct ? "số lượng sản phẩm" : "số lượng danh mục"}.
            </p>
            <p className="mb-2">
              <strong>Danh sách áp dụng:</strong>
            </p>
            <ul className="mb-3 list-unstyled">
              {action?.actionItems?.map((rule, index) => (
                <li key={index} className="d-flex justify-content-between mb-1">
                  <span>
                    -{" "}
                    {isQuantityProduct
                      ? "Số lượng sản phẩm"
                      : "Số lượng danh mục"}{" "}
                    cần mua: {rule.fromQuantity}
                  </span>
                  <span>{renderDiscountInfo(rule)}</span>
                </li>
              ))}
            </ul>
          </div>
        );

      case "product-get-product":
        return (
          <div className="p-3">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            {action.actionItems.length &&
              action.actionItems.map((rule, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between mb-3"
                >
                  <div>
                    <p className="mb-2">
                      <strong>Điều kiện (Sản phẩm mua):</strong>
                    </p>
                    {rule?.pgp_buy?.map((condition, condIndex) => (
                      <ul key={condIndex} className="list-unstyled mb-3">
                        <li>
                          - {condition.label} (Số lượng: {condition.quantity})
                        </li>
                      </ul>
                    ))}
                  </div>
                  <div>
                    <p className="mb-2">
                      <strong>Ưu đãi (Sản phẩm tặng):</strong>
                    </p>
                    {rule?.pgp_gift?.map((action, condIndex) => (
                      <ul key={condIndex} className="mb-3 list-unstyled">
                        <li>
                          - {action.label} (Số lượng: {action.quantity})
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              ))}
            {/* {action.actionItems.length > 0 ? <Separator className="my-2" /> : null } */}
          </div>
        );

      case "total-order-value-get-product":
        return (
          <div className="p-3">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p className="mb-2">
              <strong>Điều kiện:</strong> Áp dụng khi đơn hàng đủ điều kiện.
            </p>
            {action.actionItems.rules.length &&
              action?.actionItems?.rules.map((rule, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between mb-3"
                >
                  <p className="mb-2">
                    Đơn hàng từ:{" "}
                    <span>
                      <strong>
                        {formatCurrency(
                          rule?.fromValue?.toString().replace(/\./g, "")
                        )}{" "}
                        VNĐ
                      </strong>
                      {rule.toValue ? (
                        <span>
                          {" "}
                          đến{" "}
                          <strong>
                            {formatCurrency(
                              rule?.toValue?.toString().replace(/\./g, "")
                            )}{" "}
                            VNĐ
                          </strong>
                        </span>
                      ) : null}
                    </span>
                  </p>
                  <div>
                    <p className="mb-2">
                      <strong>Ưu đãi (Sản phẩm tặng):</strong>
                    </p>
                    {rule?.gifts?.map((action, condIndex) => (
                      <ul key={condIndex} className="mb-3 list-unstyled">
                        <li>
                          - {findProductName(action.productId)} (Số lượng:{" "}
                          {action.quantity})
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              ))}
            {/* {action.actionItems.rules.map((rule, index) => (
                            <div key={index} className="mb-2 border-bottom pb-2">
                                <p className="mb-1">- Đơn hàng từ <strong>{formatCurrency(rule.fromValue)} VNĐ</strong> {rule.toValue ? <strong> - {formatCurrency(rule.toValue)} VNĐ</strong> : null}:</p>
                                <ul className="list-unstyled pl-4">
                                    {rule.gifts.map((gift, giftIndex) => (
                                        <li key={giftIndex}>Tặng {findProductName(gift.productId)} (Số lượng: {gift.quantity})</li>
                                    ))}
                                </ul>
                            </div>
                         ))} */}
          </div>
        );

      case "customer-accrual-points-get-product":
        return (
          <div className="p-3">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p className="mb-2">
              <strong>Điều kiện:</strong> Áp dụng khi điểm tích lũy của khách
              hàng đủ điều kiện
            </p>
            {action.actionItems.length &&
              action.actionItems.map((rule, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between mb-3"
                >
                  <p className="mb-2">
                    Điểm tích lũy từ:{" "}
                    <span>
                      <strong>
                        {formatCurrency(
                          rule?.customer_point?.toString().replace(/\./g, "")
                        )}{" "}
                        điểm
                      </strong>
                    </span>
                  </p>
                  <div>
                    <p className="mb-2">
                      <strong>Ưu đãi (Sản phẩm tặng):</strong>
                    </p>
                    {rule?.cpgp_gift?.map((action, condIndex) => (
                      <ul key={condIndex} className="mb-3 list-unstyled">
                        <li>
                          - {action.label} (Số lượng: {action.quantity})
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              ))}
            {/* {action.actionItems.map((rule, index) => (
                        <div key={index} className="mb-2 border-bottom pb-2">
                            <p className="mb-1">- Từ <strong>{formatCurrency(rule.fromPoints)} điểm</strong>:</p>
                            <ul className="list-unstyled pl-4">
                                {rule.gifts.map((gift, giftIndex) => (
                                    <li key={giftIndex}>Tặng {findProductName(gift.productId)} (Số lượng: {gift.quantity})</li>
                                ))}
                            </ul>
                        </div>
                        ))} */}
          </div>
        );

      case "customer-group-discount":
        return (
          <div className="p-4">
            <Row className="mb-3 border-bottom">
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Đã sử dụng
                </p>
                <p>{item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Còn lại
                </p>
                <p>{item.maxUsageTotal - item.usageCount}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Tổng số lượt KM
                </p>
                <p>{item.maxUsageTotal}</p>
              </Colxx>
              <Colxx xxs="3" className="text-center">
                <p className="text-muted text-small font-weight-bold">
                  Số lượt cho mỗi KH
                </p>
                <p>{item.maxUsagePerCustomer}</p>
              </Colxx>
            </Row>
            <p className="mb-2">
              <strong>Điều kiện:</strong> Áp dụng theo hạng khách hàng
            </p>
            <ul className="mb-3 list-unstyled">
              {action?.actionItems?.map((rule, index) => (
                <li key={index} className="d-flex justify-content-between mb-1">
                  <span>
                    - Hạng <strong>{rule.customerGroup}</strong>:
                  </span>
                  <span>
                    Giảm{" "}
                    {rule.discountUnit === "PERCENT"
                      ? `${rule.discountValue}%`
                      : `${formatCurrency(rule.discountValue)} VNĐ`}
                    {rule.maxDiscount
                      ? ` (Tối đa ${formatCurrency(rule.maxDiscount)} VNĐ)`
                      : ""}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        );

      default:
        return (
          <div className="p-3 text-muted">
            Chi tiết cho loại khuyến mại này chưa được hỗ trợ hiển thị.
          </div>
        );
    }
  };

  render() {
    const { dropdownSplitOpen } = this.state;
    const {
      item,
      selectedItems,
      idx,
      onChangeCheckbox,
      isDisabledUpdate,
      onUpdate,
      isDisabledDelete,
      onToggleStatus,
    } = this.props;

    const namePromotion = () => {
      const type = this.findTypePromotion(
        item.actions[0].actionType,
        item.conditions[0].conditionType
      );
      if (type === "total-order-value") {
        return {
          label: "Giảm giá theo tổng giá trị đơn hàng",
          value: "total-order-value",
        };
      }
      if (type === "customer-accrual-points") {
        return {
          label: "Giảm giá theo mốc tích điểm của khách hàng",
          value: "customer-accrual-points",
        };
      }
      if (type === "first-order-discount") {
        return {
          label: "Giảm giá cho khách hàng mới / đơn hàng đầu tiên",
          value: "first-order-discount",
        };
      }
      if (type === "one-product") {
        return {
          label: "Giảm giá theo từng sản phẩm",
          value: "one-product",
        };
      }
      if (type === "one-type-product") {
        return {
          label: "Giảm giá theo từng danh mục sản phẩm",
          value: "one-type-product",
        };
      }
      if (type === "quantity-product") {
        return {
          label: "Giảm giá theo số lượng sản phẩm",
          value: "quantity-product",
        };
      }
      if (type === "quantity-type-product") {
        return {
          label: "Giảm giá theo số lượng danh mục",
          value: "quantity-type-product",
        };
      }
      if (type === "product-get-product") {
        return {
          label: "Mua sản phẩm - Tặng sản phẩm",
          value: "product-get-product",
        };
      }
      if (type === "total-order-value-get-product") {
        return {
          label: "Tặng quà theo giá trị đơn hàng",
          value: "total-order-value-get-product",
        };
      }
      if (type === "customer-accrual-points-get-product") {
        return {
          label: "Tặng quà theo mốc điểm của khách hàng",
          value: "customer-accrual-points-get-product",
        };
      }
      if (type === "customer-group-discount") {
        return {
          label: "Giảm giá theo hạng khách hàng",
          value: "customer-group-discount",
        };
      }
      return null;
    };

    const DAY_NAMES = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];

    const statusPromotion = () => {
      if (item.isActive === false) return "Tạm dừng";
      const now = new Date();
      if (new Date(item.startDate) > now) {
        return "Sắp diễn ra";
      } else if (
        new Date(item.endDate) < now ||
        (item.maxUsageTotal > 0 && item.usageCount >= item.maxUsageTotal)
      ) {
        return "Đã kết thúc";
      } else {
        return "Đang diễn ra";
      }
    };

    return (
      <Card
        className={classnames("mb-3 custom-shadow", {
          active: selectedItems.includes(item.id),
        })}
      >
        <div className="d-flex flex-column">
          <div className={"d-flex flex-grow-1 min-width-zero"}>
            <div
              onClick={() => this.onClickedItem(item)}
              className="card-body w-100 align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center py-3"
            >
              <div className="w-60 align-self-center d-flex flex-column justify-content-between">
                <div className="d-flex align-items-center list-item-heading mb-1 truncate d-block">
                  <span>{item.name}</span>
                </div>
                <div className="text-muted text-small">Mã số: {item.code}</div>
                <div className="text-muted text-small mt-3 mb-2">
                  {namePromotion()?.label} -{" "}
                  {statusPromotion() === "Đang diễn ra" ? (
                    <span className="text-primary">Đang diễn ra</span>
                  ) : statusPromotion() === "Sắp diễn ra" ? (
                    <span className="text-warning">Sắp diễn ra</span>
                  ) : statusPromotion() === "Tạm dừng" ? (
                    <span className="text-danger">Tạm dừng</span>
                  ) : (
                    <span className="text-muted">{statusPromotion()}</span>
                  )}
                </div>
                <div className="text-muted text-small">
                  {item.isAutoUse ? (
                    <span className="text-info">Tự động áp dụng</span>
                  ) : null}{" "}
                  {item.isAutoUse && item.isStackable ? "-" : null}{" "}
                  {item.isStackable ? (
                    <span className="text-warning">
                      Có thể kết hợp với CTKM khác.
                    </span>
                  ) : null}
                </div>
                {/* Schedule info */}
                {(item.activeTimeStart || item.activeTimeEnd || (item.activeDays && item.activeDays.length > 0)) && (
                  <div className="text-muted text-small mt-1">
                    {item.activeTimeStart || item.activeTimeEnd ? (
                      <span>
                        <i className="simple-icon-clock mr-1" />
                        {item.activeTimeStart || '00:00'} - {item.activeTimeEnd || '23:59'}
                      </span>
                    ) : null}
                    {item.activeDays && item.activeDays.length > 0 ? (
                      <span className="ml-2">
                        {[...item.activeDays].sort((a, b) => a - b).map(d => DAY_NAMES[d]).join(', ')}
                      </span>
                    ) : null}
                  </div>
                )}
              </div>
              <div className="w-40 d-flex flex-column align-items-end">
                <div className="mb-2">
                  {item.promotionType === "DISCOUNT" ? (
                    <Badge color={"primary"} pill>
                      GIẢM GIÁ
                    </Badge>
                  ) : item.promotionType === "GIFT" ? (
                    <Badge color={"secondary"} pill>
                      QUÀ TẶNG
                    </Badge>
                  ) : null}
                </div>
                {onToggleStatus && (
                  <span
                    className={`badge cursor-pointer ${item.isActive === false ? 'badge-outline-success' : 'badge-outline-warning'}`}
                    style={{ padding: '4px 8px', fontSize: '11px', cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      onToggleStatus(item);
                    }}
                  >
                    {item.isActive === false ? 'Kích hoạt' : 'Tạm dừng'}
                  </span>
                )}
              </div>
            </div>

            {/* Simple Checkbox - for multi-select */}
            <div
              className="custom-control custom-checkbox align-self-center"
              style={{
                padding: "15px 20px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onChangeCheckbox(item.id, e);
              }}
            >
              <CustomInput
                type="checkbox"
                id={`check-promotion-${item.id}`}
                label=""
                checked={selectedItems.includes(item.id)}
                onChange={() => {}}
              />
            </div>
          </div>

          <div
            className="variant-toggle-badge d-flex align-items-center text-small"
            onClick={(e) => {
              e.stopPropagation();
              this.toggleVariants();
            }}
            style={{
              cursor: "pointer",
              position: "absolute",
              bottom: "8px",
              right: "12px",
              backgroundColor: "#f0f0f0",
              padding: "4px 10px",
              borderRadius: "12px",
              fontSize: "12px",
              color: "#666",
              zIndex: 10,
            }}
          >
            <div className="flex-grow-1">Chi tiết KM</div>{" "}
            <i
              className={`simple-icon-arrow-${
                this.state.isVariantsOpen ? "up" : "down"
              } ml-1`}
              style={{ fontSize: "10px" }}
            />
          </div>

          {/* <div
              className="d-flex align-items-center mt-3 text-small text-muted"
              onClick={(e) => {
                e.stopPropagation();
                this.toggleVariants();
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="flex-grow-1">Chi tiết KM</div>{" "}
              <i
                className={`simple-icon-arrow-${
                  this.state.isVariantsOpen ? "up" : "down"
                } ml-1`}
              />
            </div> */}
          <Collapse isOpen={this.state.isVariantsOpen} className="border-top">
            {this.renderPromotionDetails(item)}
          </Collapse>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = ({ menu }) => {
  const { containerClassnames, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    containerClassnames,
    menuClickCount,
    selectedMenuHasSubItems,
  };
};
export default connect(mapStateToProps, {
  setContainerClassnames,
  clickOnMobileMenu,
})(LabelItemLeft);
